/**
 * Infrastructure Dashboard Page
 * Main page for production infrastructure management
 */

import React from 'react';
import InfrastructureDashboard from '../../components/infrastructure/InfrastructureDashboard';

const InfrastructureDashboardPage = () => {
  return (
    <div>
      <InfrastructureDashboard />
    </div>
  );
};

export default InfrastructureDashboardPage;
